module.exports = __webpack_public_path__ + "images/98aa23701375a5e68a97a87d4a9bb9a5.svg";